export const TABS = {
  ADD_MEMBER: 0,
  ASSIGN_ROLE: 1,
  CONFIRM_MEMBER: 2,
} as const;

export const INITIAL_TABS_ARRAY = {
  [TABS.ADD_MEMBER]: true,
  [TABS.ASSIGN_ROLE]: false,
  [TABS.CONFIRM_MEMBER]: false,
};
